import * as React from "react";
import classnames from "classnames";
import CampaignInfoBannerContainer from "../../../../CampaignInfoBanner/v3/components/CampaignInfoBanner/CampaignInfoBannerContainer.js";
import HeaderContainer from "../../../../Header/v3/components/Header/HeaderContainer.js";
/* empty css            */
const Layout = ({
  children,
  className,
  hasNavigation = true,
  resetHtmlScrolling = false,
  banner,
  ...rest
}) => /* @__PURE__ */ React.createElement(React.Fragment, null, resetHtmlScrolling ? /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("style", { jsx: true, global: true }, `
            /* fixes scroll to top issue */
            html {
              overflow: auto;
            }
          `)) : null, /* @__PURE__ */ React.createElement("main", { ...rest, className: classnames("book-appointment-layout", className) }, /* @__PURE__ */ React.createElement(HeaderContainer, { hasNavigation }), /* @__PURE__ */ React.createElement(CampaignInfoBannerContainer, { ...banner }), /* @__PURE__ */ React.createElement(
  "div",
  {
    "data-t": "layout-container",
    className: classnames("book-appointment-layout__container", {
      "book-appointment-layout__container--without-navigation": !hasNavigation
    })
  },
  children
)));
export {
  Layout as default
};
//# sourceMappingURL=Layout.js.map
